import axios from "axios";
import {URL_BASE} from "@/configs/constants";

const RESOURCE = 'name-budget';
export default {

    loadNameBudgets(context, params) {
        context.commit('LOADER', true)
        return new Promise((resolve, reject) => {
            axios.get(`${URL_BASE}${RESOURCE}`, {params})
                .then(response => {
                    context.commit('LOAD_NAME_BUDGET', response.data)
                    return resolve(response.data)
                }).catch(errors => {
                return reject(errors)
            }).finally(() => context.commit('LOADER', false))
        })
    },


    storeNameBudget(context, formData) {
        context.commit('LOADER', true)
        return new Promise((resolve, reject) => {
            axios.post(`${URL_BASE}${RESOURCE}`, formData)
                .then((r) => resolve(r))
                .catch(errors => reject(errors))
                .finally(() => context.commit('LOADER', false))
        })
    },

        loadNameBudget(context, id) {
       context.commit('LOADER', true)
            return new Promise((resolve, reject) => {
                axios.get(`${URL_BASE}${RESOURCE}/${id}`)
                    .then(response => resolve(response.data))
                    .catch((e) => reject(e))
                    .finally(() => context.commit('LOADER', false))
            })
        },

          updateNameBudget(context, formData) {
            context.commit('LOADER', true)
            return new Promise((resolve, reject) => {
                axios.put(`${URL_BASE}${RESOURCE}/${formData.id}`, formData)
                    .then((r) => {
                        resolve(r)
                    })
                    .catch(errors => reject(errors))
                    .finally(() => context.commit('LOADER', false))
            })
        },

    destroyNameBudget(context, id) {
        context.commit('LOADER', true)
        return new Promise((resolve, reject) => {
            axios.delete(`${URL_BASE}${RESOURCE}/${id}`)
                .then(response => resolve(response.data))
                .catch(errors => reject(errors))
                .finally(() => context.commit('LOADER', false))
        })
    },



}